import store from '@/store'
import linkExtender from './linkExtender'

const catalogPageLinkExtender = {
  idAttribute: 'data-page-id',
  selector: 'a[data-page-id]',
  dispatch: () => { },
  processor: (element, config) => {
    const pageId = element.getAttribute('data-page-id')
    const catalogId = element.getAttribute('data-catalog-id')
    const subpageId = element.getAttribute('data-sub-page-id')

    let adjustedLocalHref = `/#/ca/pages/${catalogId}/${pageId}`
    if (subpageId) {
      adjustedLocalHref += `#${subpageId}`
    }
    element.href = adjustedLocalHref
    element.addEventListener('click', (event) => {
      event.preventDefault()
      config.vm.$router.push({
        name: 'caPageEditor',
        params: {
          catalogId,
          id: pageId,
        },
      })
    })

  },
}

const extenders = [
  linkExtender(
    'data-course-id',
    (id, { effectiveDatesRange }) => store.getters['curriculumCourses/cmCourseByEffectiveDatesRangeLookup'](id, effectiveDatesRange) ||
      store.getters['curriculumCourses/cmCourseByEffectiveDatesRangeLookup'](id, effectiveDatesRange, 'deprecatedId'),
    ({ effectiveDatesRange, ids }) => store.dispatch('curriculumCourses/getCourses', {
      courseGroupIds: ids,
      effectiveDatesRange,
      columns: [ 'code', 'longName', 'name', 'deprecatedId' ],
      limit: 2000,
    }),
    'cm/course',
    'cmCourse',
    'courseId',
  ),
  linkExtender(
    'data-program-id',
    (id, { effectiveDatesRange }) => store.getters['curriculumPrograms/cmProgramByEffectiveDatesRangeLookup'](id, effectiveDatesRange) ||
      store.getters['curriculumPrograms/cmProgramByEffectiveDatesRangeLookup'](id, effectiveDatesRange, 'deprecatedId'),
    ({ effectiveDatesRange, ids }) => store.dispatch('curriculumPrograms/getPrograms', {
      programGroupIds: ids,
      effectiveDatesRange,
      columns: [ 'code', 'longName', 'name', 'deprecatedId' ],
    }),
    'cm/program',
    'cmProgram',
    'programId',
  ),
  catalogPageLinkExtender,
]

export default function extendContent (wrapperElement, config) {
  extenders.forEach(async (extender) => {
    const nodesList = wrapperElement.querySelectorAll(extender.selector)
    const ids = [ ...(nodesList.values() || []) ].map(el => el.getAttribute(extender.idAttribute))
    if (ids.length) {
      await extender.dispatch({
        ids,
        effectiveDatesRange: config.vm.effectiveDatesRange,
      })
    }
    nodesList.forEach((element) => extender.processor(element, config))
  })
}
